export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/scheduled-tasks${mapQueryString(query)}`),
    abort: (id) => axios.post(`/scheduled-tasks/${id}/abort`),
    send: (body) => axios.post(`send-broadcast-message`, body)
})



// WEBPACK FOOTER //
// ./src/api/scheduledTasks.js